import { QUERY_KEY } from "@/const/key-stores"
import { useQState } from "@/hooks/useQState"
import { CloudSign } from "@/types/cloud-sign"

export const useCloudSignInfo = () => {
  const [cloudSignInfo, setCloudSignInfo] = useQState<CloudSign>(QUERY_KEY.cloudSignInfo)

  return {cloudSignInfo, setCloudSignInfo}
}